import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { initializeAuth, browserLocalPersistence, indexedDBLocalPersistence } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId:             process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
export const db        = getFirestore(app);
export const storage   = getStorage(app);
// Local persistence: auth state survives across tabs and browser restarts.
// It used to be getAuth() (IndexedDB first) + setPersistence(local): every new
// tab migrated the session into IndexedDB — deleting the localStorage copy —
// then moved it back. Every OTHER open tab saw the delete as a sign-out, flashed
// the sign-in page and rebuilt the whole admin app (unsaved edits lost).
// localStorage FIRST: a session is always found there, so nothing migrates and
// the localStorage copy is never deleted. (A session found only in IndexedDB —
// test harnesses write one — moves to localStorage once; other tabs don't watch
// IndexedDB, so that can't flash them either.)
export const auth      = initializeAuth(app, { persistence: [browserLocalPersistence, indexedDBLocalPersistence] });
export const functions = getFunctions(app, 'northamerica-northeast1');
